import React, { useEffect } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { Checkbox } from '../../../ui';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';
import { QuestionType, ExternalDependencyType } from '../../../../core/constants/common';

const AdvancedTab = () => {
  const {
    selectedanswertype, uomRequired, setUomRequired, allowFileUpload, setAllowFileUpload,
    fileMandatory, setFileMandatory, allowComments, setAllowComments, optional,
    remarkRequired, setRemarkRequired,
    hisDataSupported, setHisDataSupported, markUnsaved,
    uomData, setUOMData, inputUnits, getSelectedUoms, onSelectDeSelectUoms,
    extDependency, handleExternalDependency, onExternalDependencyChange, extConfig, setExtConfig,
    emissionCats, onScopeChange, loadEmissionCats,
  } = useBuilderEditor();

  const isNumeric = selectedanswertype === QuestionType.NUMERIC_VALUE;

  // A question that already has an emission scope saved (reopened for edit)
  // needs its category list fetched up front — otherwise the Category select
  // has no <option> matching the saved emissionCategory yet, so it renders
  // blank until the user happens to focus it.
  useEffect(() => {
    if (extDependency?.enabled && extConfig?.emissionScope) {
      loadEmissionCats(extConfig.emissionScope);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extDependency?.enabled, extConfig?.emissionScope]);

  const showCommentsMandatory = allowComments && !optional;

  return (
    <div className="builder-property-tab">


      {isNumeric && (
        <>
          <Checkbox
            label="Unit of measure required"
            checked={uomRequired}
            onChange={(e) => { setUomRequired(e.target.checked); markUnsaved(); }}
          />
          {uomRequired && (
            <div>
              <label className="builder-label">Possible UOMs</label>

              <Multiselect
                options={inputUnits}
                selectedValues={getSelectedUoms()}
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                displayValue="label"
              />
              <label className="builder-label builder-property-tab__label--spaced">Default UOM</label>
              <select className="builder-ui-select"
                onChange={(e) => setUOMData({ ...uomData, defaultUOM: e.target.value })}
                value={uomData.defaultUOM}>
                <option value="">Select</option>
                {uomData?.relevantUoms.map(u => (
                  <option value={u} key={u}>{inputUnits?.find(ip => ip.value === u)?.label ?? u}</option>
                ))}
              </select>

            </div>
          )}

          <Checkbox
            label="External dependency"
            checked={extDependency?.enabled}
            onChange={(e) => handleExternalDependency(e.target.checked)}
          />
          {extDependency?.enabled && (
            <div className="builder-property-tab__grid">
              <select
                name='E_type'
                className="builder-ui-select"
                value={extDependency.value || ''}
                onChange={(e) => onExternalDependencyChange(e.target.value)}
              >
                <option value="">Select type</option>
                <option value={ExternalDependencyType.EMISSION_CALCULATOR}>Emission Calculator</option>
              </select>
              {extDependency.value === ExternalDependencyType.EMISSION_CALCULATOR && (
                <>
                  <select
                    name='E_scope'
                    className="builder-ui-select"
                    value={extConfig?.emissionScope || ''}
                    onChange={(e) => onScopeChange(e.target.value)}
                  >
                    <option value="">Select scope</option>
                    <option value="Scope 1">Scope 1</option>
                    <option value="Scope 2">Scope 2</option>
                    <option value="Scope 3">Scope 3</option>
                  </select>
                  <select
                    name='E_catgeory'
                    className="builder-ui-select"
                    value={extConfig?.emissionCategory || ''}
                    onChange={(e) => { setExtConfig({ ...extConfig, emissionCategory: e.target.value }); markUnsaved(); }}
                    onFocus={() => extConfig?.emissionScope && loadEmissionCats(extConfig.emissionScope)}
                  >
                    <option value="">Select category</option>
                    {emissionCats?.map((cat) => (
                      <option key={cat.id} value={cat.catgeory || cat.category}>{cat.category}</option>
                    ))}
                  </select>
                </>
              )}
            </div>
          )}

          <Checkbox
            label="Support historical data"
            checked={hisDataSupported}
            onChange={(e) => { setHisDataSupported(e.target.checked); markUnsaved(); }}
          />
        </>
      )}
      <div className="builder-property-tab__panel">
        <p className="builder-label builder-property-tab__label--flush">Comments & attachments</p>
        <div className="builder-property-tab__row">
          <Checkbox
            label="Allow file upload"
            checked={allowFileUpload}
            onChange={(e) => { setAllowFileUpload(e.target.checked); markUnsaved(); }}
          />
          {allowFileUpload && !optional && (
            <Checkbox
              label="File upload mandatory"
              checked={fileMandatory}
              onChange={(e) => { setFileMandatory(e.target.checked); markUnsaved(); }}
            />
          )}
        </div>
        <div className="builder-property-tab__row">
          <Checkbox
            label="Allow comments"
            checked={allowComments}
            onChange={(e) => {
              setAllowComments(e.target.checked);
              if (!e.target.checked) setRemarkRequired(false);
              markUnsaved();
            }}
          />
          {showCommentsMandatory && (
            <Checkbox
              label="Comments mandatory"
              checked={remarkRequired}
              onChange={(e) => { setRemarkRequired(e.target.checked); markUnsaved(); }}
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default AdvancedTab;
